function searchVendors () {
  const filter = document.getElementById('search-vendors-input').value
  const ul = document.getElementById('vendors-home-list')
  const li = ul.getElementsByTagName('li')
  for (let i = 0; i < li.length; i++) {
    const elemText = li[i].getElementsByTagName('a')[0].text
    li[i].style.display = !filter || elemText.toUpperCase().includes(filter.toUpperCase()) ? '' : 'none'
  }
}

const searchVendorInput = $('#search-vendors-input')

searchVendorInput.focusin(function () {
  $('#vendors-home-list').fadeIn('fast')
})
searchVendorInput.focusout(function () {
  $('#vendors-home-list').fadeOut(1000)
})
searchVendorInput.on('keyup', function () { searchVendors() })

$('.home-banners-mob-slider').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 5000,
      settings: 'unslick'
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
})

$('.three-col-slider').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 3000,
      settings: 'unslick'
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
})

$('.slider-wrapper-flex').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 3000,
      settings: 'unslick'
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 450,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
})


$('.home-bc-slider').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 8,
  slidesToScroll: 8,
  responsive: [
    {
      breakpoint: 5000,
      settings: 'unslick'
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
})

$('.home-tabs-prod-slider').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 5000,
      settings: 'unslick'
    },
    {
      breakpoint: 1200,
      settings: {
        dots: true,
        slidesToShow: 4,
        slidesToScroll: 4
      }
    },
    {
      breakpoint: 1024,
      settings: {
        dots: true,
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 768,
      settings: {
        dots: true,
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
})
